import {
  Alert,
  AlertTitle,
  Avatar,
  AvatarGroup,
  Box,
  Typography,
} from '@mui/material';
import { memo, useMemo } from 'react';
import * as Styled from './styles';
import type { SearchLimitAlertDialogFreeUserMessageProps as Props } from './types';

export const SearchLimitAlertDialogFreeUserMessage = memo(
  ({ className }: Props) => {
    const avatars = useMemo(
      () => [
        '/assets/avatar/anousheh-ansari.png?v=1',
        '/assets/avatar/company1.png?v=1',
        '/assets/avatar/company5.png?v=1',
        '/assets/avatar/garry-tan.png?v=1',
        '/assets/avatar/company2.png?v=1',
        '/assets/avatar/claire-hughes-johnson.png?v=1',
        '/assets/avatar/company4.png?v=1',
      ],
      []
    );

    return (
      <Styled.Wrapper>
        <Box sx={{ display: 'flex', justifyContent: 'center' }}>
          <AvatarGroup spacing={'small'} max={7}>
            {avatars.map((x, i) => (
              <Avatar
                key={i.toString()}
                sx={{ width: 40, height: 40 }}
                src={x}
              />
            ))}
          </AvatarGroup>
        </Box>
        <Typography
          variant="body3"
          color="grey.600"
          fontWeight={500}
          textAlign={'center'}
        >
          Your Free Plan search limit has been reached. Your access will reset
          automatically in 24 hours.
        </Typography>
        <Alert severity="info" icon={false}>
          <AlertTitle>Important Note</AlertTitle>
          Daily search requests are limited on the Free Plan.{' '}
          <div style={{ display: 'inline' }}>
            <u>
              <b>Upgrade</b>
            </u>{' '}
            to unlock thousands of daily searches and full access.
          </div>
        </Alert>
      </Styled.Wrapper>
    );
  }
);

SearchLimitAlertDialogFreeUserMessage.displayName =
  'SearchLimitAlertDialogFreeUserMessage';
